import React, { useState } from 'react'
import {
  Box,
  Button,
  Field,
  Flex,
  Message,
  Modal,
  Text,
  Textarea,
  toast,
} from '@workwhile/ui'
import { formatCurrency } from 'lib/currency'
import { CopyableLink } from 'components/Shared/CopyableLink'
import { useUserPaymentsContextValue } from '../../context/UserPaymentsProvider'

export const CancelBonusModal = () => {
  const {
    state: { cancelBonus },
    actions: { closeCancelBonus, submitCancelBonus },
  } = useUserPaymentsContextValue()

  const [comment, setComment] = useState('')

  if (!cancelBonus) {
    return null
  }

  const { payment, mutationState } = cancelBonus

  const canSubmit = comment.trim().length > 0 && !mutationState.isPending

  const handleConfirm = () => {
    submitCancelBonus(
      { comment: comment.trim() },
      {
        onSuccess: (data) => {
          toast.success(
            `Bonus of ${formatCurrency(Number(data.amount))} canceled`,
            { position: 'top-center' }
          )
          closeCancelBonus()
        },
      }
    )
  }

  return (
    <Modal
      open
      onClose={closeCancelBonus}
      position="top"
      title="Cancel bonus"
      showCancel
      customCta={
        <Flex>
          <Button
            variant="text"
            onClick={closeCancelBonus}
            disabled={mutationState.isPending}
          >
            Keep bonus
          </Button>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            disabled={!canSubmit}
            loading={mutationState.isPending}
          >
            Confirm cancel bonus
          </Button>
        </Flex>
      }
    >
      <Box mt={3}>
        <Text>
          <Text as="span" fontWeight="bold">
            Worker:
          </Text>{' '}
          {payment.userName} (
          <CopyableLink
            label={payment.userId}
            link={`/users/${payment.userId}`}
          />
          )
        </Text>
      </Box>

      <Box
        mt={3}
        p={3}
        bg="background"
        borderRadius="xxlarge"
        textAlign="center"
      >
        <Flex justifyContent="center" alignItems="center" gap={1}>
          <Text fontSize={1} fontWeight={500}>
            Bonus
          </Text>
          <CopyableLink
            label={payment.id}
            link={`/user_payments?payment-id=${payment.id}`}
          />
        </Flex>
        <Text mt={1} fontSize={2} fontWeight="bold">
          {formatCurrency(payment.amount)}
        </Text>
        {payment.comment ? (
          <Text mt={1} fontSize={1}>
            {payment.comment}
          </Text>
        ) : null}
      </Box>

      <Message variant="warning" mt={3}>
        The worker can no longer cash out this bonus. You cannot undo this
        action.
      </Message>

      <Box mt={3}>
        <Field label="Comment">
          <Textarea
            aria-label="Comment"
            placeholder="Explain why this bonus is canceled"
            value={comment}
            onChange={(event) => setComment(event.target.value)}
            rows={3}
            required
            disabled={mutationState.isPending}
          />
        </Field>
      </Box>

      {mutationState.errorMessage ? (
        <Message variant="error" mt={3}>
          {mutationState.errorMessage}
        </Message>
      ) : null}
    </Modal>
  )
}
